import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography, TextField } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { useStyles } from './styles.js';
import _ from 'lodash';

class LonewolfSelections extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { classes, quarters, groupsData } = this.props;
    if (
      this.props.state.playersData &&
      Object.keys(this.props.state.playersData).length == 0
    ) {
      this.props.getPlayersView();
    }

    return (
      <div>
        {this.props.playersData &&
          Object.keys(this.props.playersData).length > 0 &&
          Object.keys(this.props.playersData).map(key => {
            const quarter_name = quarters.find(q => q.quarter_number == key) ? quarters.find(q => q.quarter_number == key).quarter_name : `Quarter ID: ${key}` ;
            return (
              <div
                style={{
                  width: '100%',
                  alignItems: 'baseline',
                }}
              >
                <Typography
                  style={{
                    fontSize: '20px',
                    marginTop: '50px',
                    marginBottom: '50px',
                  }}
                >
                  {quarter_name}
                </Typography>

                {Object.keys(this.props.playersData[key]).map(p => {
                  const current_answer = this.props.answers && this.props.answers.filter(a => a.group_number == parseInt(p) && a.quarter_id == parseInt(key));
                  const group_data = groupsData ? _.filter(groupsData, {'quarter_id': parseInt(key), 'group_number': parseInt(p)}) : null;
                  let declared = false;
                  if(group_data && group_data[0]) declared = group_data[0].winner != null;
                  if(!declared) return (
                    <div
                      style={{
                        borderBottom: '0.5px gray',
                        marginBottom: '20px',
                        padding: '20px',
                      }}
                    >
                      <Typography
                        style={{ fontSize: '16px', marginBottom: '20px' }}
                      >
                        Group number: {p}{' '}
                      </Typography>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                      >
                        {this.props.playersData[key][p].map(player => {
                          return (
                            <Grid item xs={3} md={3}>
                              <div
                                className={
                                  player.distance || declared ?
                                  classes.disabledContainer :
                                  this.props.edit
                                    ? this.props.state[`${p}_${key}`] &&
                                      this.props.state[`${p}_${key}`]
                                        .response == player.player_name
                                      ? classes.memberHighlightContainer
                                      : classes.memberContainer
                                    : this.props.state[`${p}_${key}`] ==
                                      player.player_name
                                    ? classes.memberHighlightContainer
                                    : classes.memberContainer
                                }
                                onClick={() =>
                                  this.props.handleClick(
                                    `${p}_${key}`,
                                    player.player_name,
                                  )
                                }
                              >
                                <Typography style={player.distance ? { color: 'gray' } : {}}>
                                  {player.player_name.length >= 15
                                    ? player.player_name.substring(0, 14) +
                                      '...'
                                    : player.player_name}
                                </Typography>
                              </div>
                            </Grid>
                          );
                        })}
                      </div>
                      <TextField
                        label={`Enter ${
                          this.props.game.settings.split(',')[0]
                        },${current_answer && current_answer[0] ? current_answer[0].money : this.props.game.settings.split(',')[1]}`}
                        type="number"
                        InputProps={{ inputProps: { min: 0 } }}
                        value={
                          this.props.state[`${key}_${p}_money`]
                            ? parseInt(this.props.state[`${key}_${p}_money`])
                            : null
                        }
                        name={`${p}_${key}_money`}
                        className={classes.textField}
                        margin="normal"
                        fullWidth
                        onChange={this.props.handleOnChange}
                        style={{ marginBottom: '50px' }}
                        disabled={declared}
                      />
                    </div>
                  );
                })}
              </div>
            );
          })}
      </div>
    );
  }
}

LonewolfSelections.propTypes = {
  className: PropTypes.string,
};

export default withStyles(useStyles)(LonewolfSelections);
